import EntityService from '../../services/EntityService.js'

export const namespaced = true

export const state = {
  entities: [],
  entity: {}
}

export const mutations = {
  ADD_ENTITY(state, entity) {
    state.entities.push(entity)
  },
  SET_ENTITIES(state, entities) {
    state.entities = entities
  },
  SET_ENTITY(state, entity) {
    state.entity = entity
  },
  UPDATE_ENTITY(state, entity) {
    state.entities = [...state.entities.filter(e => e.entityID !== entity.entityID), entity]
  },
  DELETE_ENTITY(state, id) {
    state.entities = [...state.entities.filter(e => e.entityID !== id)]
  }
}

export const actions = {
  save({ commit }, entity) {
    if (entity.entityID) {
      return EntityService.put(entity).then(res => {
        const e = res.data
        commit('UPDATE_ENTITY', e)
        commit('SET_ENTITY', e)
      })
    } else {
      return EntityService.post(entity).then(res => {
        const e = res.data
        commit('ADD_ENTITY', e)
        commit('SET_ENTITY', e)
      })
    }
  },
  delete({ commit }, id) {
    return EntityService.delete(id).then(() => {
      commit('DELETE_ENTITY', id)
    })
  },
  getByChange({ commit }, id) {
    return EntityService.getByChange(id).then(res => {
      commit('SET_ENTITIES', res.data)
    })
  },
  set({ commit }, id) {
    return new Promise((resolve, reject) => {
      const entity = state.entities.find(e => e.entityID == id)
      if (!entity) return reject()
      commit('SET_ENTITY', entity)
      resolve(entity)
    })
  },
  clearEntity({ commit }) {
    return new Promise(resolve => {
      commit('SET_ENTITY', {})
      resolve()
    })
  },
  clear({ commit }) {
    return new Promise(resolve => {
      commit('SET_ENTITY', {})
      commit('SET_ENTITIES', [])
      resolve()
    })
  },
  setEntities({ commit }, entities) {
    return new Promise(resolve => {
      commit('SET_ENTITIES', entities)
      resolve()
    })
  }
}

export const getters = {
  entitiesForChange: (state, getters, rootState) => state.entities.filter(e => e.changeID == rootState.change.change.changeID)
}